@if (label) {
  <div class="api-environment-banner" [title]="label">
    {{ label }}
  </div>
}
